import Link from "ds/components/Link";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemGrantedAtCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemGrantedAtCell = ({
  roleBinding,
}: ApiKeyRolesListItemGrantedAtCellProps) => {
  return (
    <Link
      size="small"
      href={`/spaces/${roleBinding.space.id}`}
      onPress={() => {
        // TODO: Add analytics when implemented
      }}
    >
      {roleBinding.space.name}
    </Link>
  );
};

export default ApiKeyRolesListItemGrantedAtCell;
